$(function() {
    var firstLoad = 2;
	// tabbing
	$('.tab a[data-filter], .filter-closer').on('click', function(event) {
        if (!$(this).hasClass('direct')) {
            event.preventDefault();

            var tab = $(this).attr('href');

            if ($(tab).css('display') == 'none') {
                $('.filter-tab-content').hide();
                $(tab).addClass('filter-tab-opening');
                $(tab).show(function () {
                    $(tab).removeClass('filter-tab-opening');
                });
            } else {
                if (firstLoad < 1) {
                    $(tab).addClass('filter-tab-closing');

                    $(tab).hide(1000, function () {
                        $(tab).removeClass('filter-tab-closing');
                    });
                } else {
                    firstLoad--;
                }


            }

            event.stopPropagation();
        }
    });

   $(window).on('scroll', function () {
        var visibleContent = $('.filter-tab-content:visible').first();
        if (visibleContent.length && !visibleContent.hasClass('filter-tab-closing') && !visibleContent.hasClass('filter-tab-opening') && $(window).width() > 992) {
            // visibleContent.find('.filter-closer').trigger('click');
        }
    });
});



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/filter/tabs.js
 **/